module.exports = __webpack_public_path__ + "img/blue-circle-table-2.5ba7cc01.png";